// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"1a66074d","160":"2f145fcd","208":"4fb0343a","293":"97167dae","453":"ad7768ec","516":"5275bf50","519":"4918736b","917":"eeebfa71","946":"fba57df7"}[chunkId] + ".chunk.js";
};